import Vue from 'vue';
import $ from 'jquery';

Vue.directive('numero', function(el, binding){
  $(el).on('keypress', function(evt) {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    
    if (charCode > 47 && charCode < 58) {
      return true;
    } else {
      evt.preventDefault();
    }
  });
});



// WEBPACK FOOTER //
// ./FrontEnd/diretivas/numero.js